import { request } from '../request'

const blog = {
    // 获取置顶文章
    getTop: () => request('/api/blog/get_top', 'get'),
    // 获取右侧Top hits
    getTopHits: () => request('/api/blog/get_top_hits', 'get'),
    // 获取blog列表
    getBlogList: data => request('/api/blog/lists', 'get', data),
    // 获取blog详情
    getBlogDetail: data => request('/api/blog/details', 'get', data),
    // 获取Tag详情
    getTagDetail: data => request('/api/blog/tag', 'get', data),
    // 获取Tag列表
    getTagList: data => request('/api/blog/tags', 'get', data),
    // 获取作者详情
    getAuthorDetail: data => request('/api/blog/author', 'get', data),
}
export default blog

